import axios from 'axios';
import store from '@/store';

let apiEndpoint = process.env.VUE_APP_API_BASEURL
const s3Bucket = (process.env.VUE_APP_AWS_S3_BUCKET || process.env.AWS_S3_BUCKET || 'screened').replace(/\/+$/, '');
const s3Region = process.env.VUE_APP_AWS_S3_REGION || process.env.AWS_S3_REGION || 'ap-southeast-2';
const s3PublicBaseUrl = `https://${s3Bucket}.s3.${s3Region}.amazonaws.com`;

export default {
    getIndustries() {
        return axios.get(`${apiEndpoint}/contractor/industries`);
    },
    getRoles(industryId) {
        return axios.get(`${apiEndpoint}/contractor/roles/${industryId}`);
    },
    getQuestions(roleId) {
        return axios.get(`${apiEndpoint}/contractor/questions/${roleId}`);
    },
    getExpertiseOptions(roleId) {
        return axios.get(`${apiEndpoint}/contractor/expertise-options/${roleId}`);
    },
    getProfilePictureLink(pictureHash, pictureS3Key, cacheBust = false) {
        if (pictureS3Key) {
            const base = `${s3PublicBaseUrl}/${pictureS3Key}`;
            return cacheBust ? `${base}?t=${Date.now()}` : base;
        }

        if (pictureHash) {
            const base = apiEndpoint + '/pictures/' + pictureHash + '-cropped.jpg';
            return cacheBust ? `${base}?t=${Date.now()}` : base;
        }

        return null;
    },
    getContractorProfileView(uuid) {
        let token = ''

        if (store.state.isContractorLoggedIn) {
            token = 'contractorToken'
        } else if (store.state.isCompanyLoggedIn) {
            token = 'companyToken'
        }

        return axios.get(`${apiEndpoint}/contractors/${uuid}`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem(token),
            }
        });
    }
}
